import React from 'react';
import { LiveChatYouTube } from '../../atoms/LiveChatYoutube';
import { PlayerType } from '../../../models/video';

interface PlayerLiveChatProps {
  playerType: PlayerType;
  token: string;
  className?: string;
}

const PlayerLiveChat: React.FC<PlayerLiveChatProps> = (props) => {
  const { playerType = 'sambatech' } = props;

  const playerRenderers = {
    sambatech: () => null,
    samba: () => null,
    vimeo: () => null,
    youtube: () => <LiveChatYouTube {...props} />,
  };

  const renderChat = () => {
    const Renderer = playerRenderers[playerType];
    return Renderer ? <Renderer /> : <></>;
  };

  return <div className={`${props.className ?? ''}`}>{renderChat()}</div>;
};

export default React.memo(PlayerLiveChat);
